import { getHttpClient, unwrapContainer } from '@/api/client/http-client';
import type {
  NAInterfaceResponseObj,
  NAGlobalGeofence,
  GlobalGeofenceListAddEntryReqObj,
  GlobalGeofenceListDeleteEntryReqObj,
} from '@/api/models';

export async function getGlobalGeofenceList(
  deviceUUID: string,
): Promise<NAGlobalGeofence[]> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Geofence/List',
    { deviceUUID },
  );
  return unwrapContainer<NAGlobalGeofence[]>(response.data);
}

export async function addGlobalGeofence(
  req: GlobalGeofenceListAddEntryReqObj,
): Promise<NAInterfaceResponseObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Geofence/Add',
    req,
  );
  return response.data;
}

export async function deleteGlobalGeofence(
  req: GlobalGeofenceListDeleteEntryReqObj,
): Promise<NAInterfaceResponseObj> {
  const client = getHttpClient();
  const response = await client.post<NAInterfaceResponseObj>(
    '/Geofence/Delete',
    req,
  );
  return response.data;
}
